import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'react-final-form'
import { withTheme } from 'react-jss'
import classNames from 'classnames'

import FormInput from 'components/form/form-input'

import styles from 'components/form/form-style'
import { isInputWithError } from 'helpers/form'

const SelectInput = props => {
  const classes = styles(props.theme)

  const inputClassNames = meta => classNames(
    classes.selectInput,
    { [classes.inputWithError]: isInputWithError(meta) },
    { [classes.focusedInput]: meta.active },
  )

  return (
    <Field name={props.name}>
      {({ input, meta }) => (
        <FormInput label={props.label} meta={meta} input={input} dynamicLabel>
          <select {...input} className={inputClassNames(meta)}>
            <option value="">{props.placeholder}</option>
            {props.options.map(option =>
              <option value={option.id} key={option.id}>{option.name}</option>
            )}
          </select>
          {props.children}
        </FormInput>
      )}
    </Field>
  )
}

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  theme: PropTypes.object.isRequired,
  children: PropTypes.node,
  options: PropTypes.array.isRequired,
}

SelectInput.defaultProps = {
  type: 'text'
}

export default withTheme(SelectInput)
